import { DataPanelAutoWrapInlineItem } from '@/ui';
import type { Caller } from '@/signalr';
import { DateFormatter } from '@/features/shared/DateFormatter';

type GoogleElsSource = NonNullable<Caller['dataSources']['currentGoogleEls']>;

export type GoogleElsDiagnosticsPanelItemsProps = {
  source: GoogleElsSource;
};

export function GoogleElsDiagnosticsPanelItems({ source }: GoogleElsDiagnosticsPanelItemsProps) {
  const network = [
    source.device?.homeMcc,
    source.device?.homeMnc,
    source.device?.networkMcc,
    source.device?.networkMnc,
  ]
    .filter((part): part is string => part != null && part !== '')
    .join(' / ');

  return (
    <>
      <DataPanelAutoWrapInlineItem title="Activation source" value={source.activationSource} />
      <DataPanelAutoWrapInlineItem
        title="Dialled number"
        value={source.dialledNumber ?? undefined}
        showEmptyPlaceholder
      />

      <DataPanelAutoWrapInlineItem title="Session started">
        {source.sessionStartedAtUtc == null ? (
          '–'
        ) : (
          <DateFormatter date={source.sessionStartedAtUtc} formatType="calendar" />
        )}
      </DataPanelAutoWrapInlineItem>
      <DataPanelAutoWrapInlineItem title="First received">
        <DateFormatter date={source.firstReceivedAtUtc} formatType="calendar" />
      </DataPanelAutoWrapInlineItem>
      <DataPanelAutoWrapInlineItem
        title="Protocol / Google ELS module version"
        value={[source.protocolVersion, source.googleElsModuleVersion]
          .filter((part): part is number => part != null)
          .join(' / ')}
        showEmptyPlaceholder
      />
      <DataPanelAutoWrapInlineItem
        title="Device model"
        value={source.device?.model ?? undefined}
        showEmptyPlaceholder
      />
      <DataPanelAutoWrapInlineItem title="Home / network MCC-MNC" value={network} showEmptyPlaceholder />
      <DataPanelAutoWrapInlineItem
        title="Medic data updated"
        value={source.medicData?.lastUpdatedAtUtc ?? undefined}
        showEmptyPlaceholder
      />
      <DataPanelAutoWrapInlineItem
        title="Anomalies"
        value={
          source.anomalies.length === 0
            ? undefined
            : source.anomalies.map((anomaly) => `${anomaly.field} (${anomaly.kind})`).join(', ')
        }
        showEmptyPlaceholder
      />
    </>
  );
}
